import { render, staticRenderFns } from "./Junk.vue?vue&type=template&id=6c7db6e8"
import script from "./Junk.vue?vue&type=script&lang=js"
export * from "./Junk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports